(function () {
  if (window.__pcardActions) return;
  window.__pcardActions = true;
  document.addEventListener('click', function (e) {
    var pill = e.target.closest && e.target.closest('.pcard-variant');
    if (!pill || pill.getAttribute('aria-disabled') === 'true') return;
    var wrap = pill.closest('[data-pcard]');
    if (!wrap) return;
    wrap.querySelectorAll('.pcard-variant').forEach(function (b) { b.classList.remove('is-active'); });
    pill.classList.add('is-active');
    var input = wrap.querySelector('[data-pcard-id]');
    if (input) input.value = pill.getAttribute('data-variant-id');
    var price = wrap.querySelector('.pcard-price__value');
    if (price && pill.getAttribute('data-price')) price.innerHTML = pill.getAttribute('data-price');
    var un = pill.classList.contains('is-unavailable');
    var add = wrap.querySelector('.pcard-add'); if (add) add.disabled = un;
    var sub = wrap.querySelector('.pcard-submit'); if (sub) sub.disabled = un;
  });
})();
